import CruciblePiece from './cruciblePiece';
import * as config from '../config.json';
import * as THREE from 'three';
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader';
import { PlanetaryClockConfig } from '../config';

export class PlanetaryClock extends CruciblePiece {
  protected _config: PlanetaryClockConfig;
  protected _planetNode: THREE.Object3D;
  protected _ringNode: THREE.Object3D;
  protected _isAnimating: boolean;
  protected _time: number;
  protected _speed: number;
  protected _direction: number;

  constructor() {
    super();
    this._config = config.planetaryClock;
    this._planetNode = new THREE.Object3D();
    this._ringNode = new THREE.Object3D();
    this._isAnimating = false;
    this._time = 0;
    this._speed = 0.25;
    this._direction = 1;
  }

  setup(gltf: GLTF) {
    this.group = gltf.scene;
    this.group.scale.set(0.02, 0.02, 0.02); // This should be removed with final models

    this.group.traverse((node: any) => {
      if (node.isMesh) {
        node.castShadow = true;
        node.receiveShadow = true;
        if (node.material.map) node.material.map.anisotropy = 16;
      }
      if (node.name === this._config.planetNodeName) {
        this._planetNode = node;
      }
      if (node.name === this._config.ringNodeName) {
        this._ringNode = node;
      }
    });
  }

  animate(timeElapsed: number) {
    if (this._isAnimating) {
      this._spinAnimation(1.25, timeElapsed, this._time);
    } else {
      this._planetNode.rotation.z -=
        this._config.planetRotationSpeed * timeElapsed;

      this._ringNode.rotation.x += this._config.ringRotationSpeed * timeElapsed;
      // this._ringNode.rotation.y -= this._config.ringRotationSpeed * timeElapsed;
    }
  }

  playOnClick(raycaster: THREE.Raycaster) {
    const intersects = raycaster.intersectObjects(this.group.children, true);

    if (intersects.length > 0) {
      this._isAnimating = true;
      this._time = 0;

      if (this._direction === 1) this._direction = -1;
      else this._direction = 1;
    }
  }

  _spinAnimation(duration: number, timeElapsed: number, time: number = 0) {
    this._time += timeElapsed;

    if (this._time < duration) {
      let t = this._time / duration;
      t = t * t * (3 - 2 * t);

      if (this._time < duration * 0.7) {
        this._planetNode.rotation.z += this._direction * t * this._speed;
      } else {
        this._ringNode.rotation.x -= this._direction * t * (this._speed / 2);
        this._ringNode.rotation.y -= this._direction * t * (this._speed / 2);
      }
    } else {
      this._isAnimating = false;
    }
  }
}
